function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.55 18.207l-.738.736.181 1.028 1.095 6.181-5.091-2.926-.997-.574-.997.574-5.091 2.926 1.095-6.181.183-1.028-.739-.736-4.431-4.424 5.949-.816 1.098-.152.454-1.008L16 6.3l2.48 5.507.455 1.008 1.096.152 5.95.816-4.431 4.424zm6.502-6.157l-7.748-1.066-3.305-7.338A1.082 1.082 0 0016 3c-.402 0-.804.216-.998.646l-3.305 7.338-7.749 1.066c-.898.123-1.267 1.226-.624 1.869l5.714 5.703-1.432 8.083A1.101 1.101 0 008.686 29c.18 0 .366-.046.544-.148L16 24.96l6.771 3.892c.177.102.364.148.544.148.638 0 1.207-.578 1.08-1.295l-1.432-8.083 5.713-5.703c.644-.643.274-1.746-.624-1.869z",
    fill: props.color
  }));
}

export default SvgIconMenuStarOutline;